import { Component, OnInit, Output, Inject, HostListener } from '@angular/core';
import { CreditAppService } from '../../../../services/credit-app.service';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { IConfig } from '../../../../interfaces/config.interface';
import { AnalyticsEventService } from '../../../../../lib/services/analytics-event.service';
import { IAnalyticsErrorResponse } from '../../../../../lib/interfaces/analytics.interface';
import { ErrorType, UDOConstant } from '../../../../../lib/enum/analytics.enum';
import { ComponentName } from '../../../../../lib/enum/component-name.enum';
import { ComponentGroup } from '../../../../../lib/enum/component-group.enum';
import { StepType } from '../../../../../lib/enum/step-type.enum';
import { StepComponent } from '../stepcomponent.class';
import { ServerError, UnlockCreditApp } from '../../../../../lib/actions/analytics.action';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dt-unlock',
  templateUrl: './unlock.component.html',
  styleUrls: ['./unlock.component.scss'],
  standalone: false
})
export class UnlockComponent implements OnInit {
  @Output()
  unlocked = new BehaviorSubject(true);

  ssnForm: UntypedFormGroup;
  ssnmask = ['X', 'X', 'X', ' ', '-', ' ', 'X', 'X', ' ', '-', ' ', /\d/, /\d/, /\d/, /\d/];
  serverError = false;
  errorMessage = 'Please provide the last 4 digits of your Social Security Number';
  unlockCTA = 'Submit';
  isBuyNow = false;
  inMobile = false;

  // tslint:disable-next-line: variable-name
  private _formSubmitAttempt = false;
  public get formSubmitAttempt(): boolean {
    return this._formSubmitAttempt;
  }
  public set formSubmitAttempt(value: boolean) {
    this._formSubmitAttempt = value;
  }

  constructor(@Inject('config') public config: IConfig,
              private readonly creditAppService: CreditAppService,
              private readonly fb: UntypedFormBuilder,
              private analyticsEventService: AnalyticsEventService) {
                if (this.config.Sitecore && this.config.Sitecore.CreditApplicationInfo) {
                  if (this.config.Sitecore.CreditApplicationInfo &&
                    this.config.Sitecore.CreditApplicationInfo.CompassCreditApplication &&
                    this.config.Sitecore.CreditApplicationInfo.CompassCreditApplication.Status === 4) {
                    this.creditAppService.CreditApplication.step = 13;
                    this.unlocked.next(true);
                  } else {
                    this.unlocked.next(this.config.Sitecore.CreditApplicationInfo.Unlocked);
                    this.errorMessage = this.config.Sitecore.CreditApplicationConfig.UnlockError;
                    this.unlockCTA = this.config.Sitecore.CreditApplicationConfig.UnlockCTA;
                  }
                }
  }

  ngOnInit() {
    this.ssnForm = this.fb.group({
      ssn: ['', [Validators.required, Validators.pattern('^XXX - XX - [0-9]{4}$')]]
    });
    if (this.config.Sitecore ) {
      this.isBuyNow = this.config.Sitecore.isBuyNow;
    }
    this.ssnForm.valueChanges.subscribe( values => this.serverError = false);
    this.inMobile = window.innerWidth < 768;
  }

  getCreditApp() {
    this.formSubmitAttempt = true;
    if (this.ssnForm.valid) {
      this.serverError = false;
      this.toggleNav();
      this.creditAppService.GetCreditApp({
        ApplicantLast4SSN: this.ssnForm.get('ssn').value.substr(11, 4)
      }).subscribe(response => {
        if (response.IsSuccess) {
          this.analyticsEventService.reportAnalyticsEvent(
            new UnlockCreditApp(new StepComponent(UnlockComponent,
                        ComponentName.UnlockComponent,
                        ComponentGroup.UnlockCreditApp, true, StepType.General))
          );

          this.unlocked.next(true);
        } else {
          this.serverError = true;
        }
        this.toggleNav();
      }, error => {
        this.reportErrorResponse(error);
        this.toggleNav();
      });

    }

  }

  toggleNav() {
    try {
      /* istanbul ignore next */
      (window as any)?.buynow?.navigation?.toggleNavigationDisableState();
    } catch (e) {
      /* istanbul ignore next */
      console.log(e);
    }
  }

  reportErrorResponse(errorData: any) {
    const analyticsErrorResponse: IAnalyticsErrorResponse = {
      error: errorData.statusCode ? errorData.statusCode : UDOConstant.ErrorCode,
      error_message: errorData.message ? errorData.message : UDOConstant.ServiceUnavailable,
      error_type: ErrorType.CreditAppNotSaved
    };
    this.analyticsEventService.reportAnalyticsEvent(
          new ServerError(new StepComponent(UnlockComponent,
                                            ComponentName.UnlockComponent,
                                            ComponentGroup.ResidenceInfo, true, StepType.General),
                                            analyticsErrorResponse));
  }

  @HostListener('window:resize', ['$event'])
  isMobile(e) {
    /* istanbul ignore next */
    this.inMobile = (window.innerWidth < 768);
  }

}
